// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"5e9a6c19","635":"987f4592","703":"36a7d379"}[chunkId] + ".chunk.js";
};